// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as StockQuantity from "../../core/StockQuantity.res.js";

function signFromKind(kind) {
  if (kind === "RESET") {
    return "=";
  } else if (kind === "RECEPTION" || kind === "CREDIT_MEMO" || kind === "REFUND" || kind === "DELIVERY" || kind === "INCOMING_TRANSFER") {
    return "+";
  } else {
    return "-";
  }
}

function format(kind, capacityPrecision, capacityUnit, value) {
  let value$1 = StockQuantity.fromRawValue(capacityPrecision, value);
  let unit;
  if (capacityUnit !== undefined) {
    switch (capacityUnit) {
      case "G" :
      case "g" :
        unit = "gram";
        break;
      case "KG" :
      case "kg" :
        unit = "kilogram";
        break;
      case "L" :
      case "l" :
        unit = "liter";
        break;
      default:
        unit = undefined;
    }
  } else {
    unit = undefined;
  }
  return signFromKind(kind) + (
    unit !== undefined ? I18n.unitFormat(unit, undefined, undefined, value$1) : (
        capacityUnit !== undefined ? I18n.decimalFormat(undefined, undefined, undefined, undefined, value$1) + " " + capacityUnit : I18n.decimalFormat(undefined, undefined, undefined, undefined, value$1)
      )
  );
}

export {
  signFromKind,
  format,
}
/* I18n Not a pure module */
